import { render, staticRenderFns } from "./WordListB.vue?vue&type=template&id=1a218d39&scoped=true&"
import script from "./WordListB.vue?vue&type=script&lang=ts&"
export * from "./WordListB.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a218d39",
  null
  
)

export default component.exports